import { Button, ButtonGroup, ClickAwayListener, Grid, Grow, makeStyles, MenuItem, MenuList, Paper, Popper } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useForm } from "../../hooks/useForm";
import { useDispatch, useSelector } from 'react-redux';
import TableSubidaArchivos from './TableSubidaArchivos';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import LoadingBeforeViewData from '../compartidos/LoadingBeforeViewData';
import { setArchivosMigracion, getArchivosMigracion, getParametrosImportacion, subirArchivoMigracionNuevoHandler, subirArchivoMigracion } from '../../actions/archivosMigracion';
import { TIPOS_ARCHIVOS_MIGRACION } from '../../utils/constants';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(2)
    },
    rootDatos: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        padding: 10,
        marginTop: 20
    },
    button: {
        marginTop: theme.spacing(2),
        float: "right"
    },
    input: {
        display: 'none',
    },
}));

const stateInitial = {
    selectedDateDesde: null,
    selectedDateHasta: null,
    selectedTipoArchivo: "0"
};

const SubidaArchivosScreen = () => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const { archivos, parametrosImportacion } = useSelector(state => state.archivosMigracion)
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);

    const [formValues, , , setearValor] = useForm(stateInitial);
    const { selectedDateDesde, selectedDateHasta, selectedTipoArchivo } = formValues;

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const handleChangeFile = (e) => {
        debugger
        if (parametrosImportacion[selectedIndex].idParam === TIPOS_ARCHIVOS_MIGRACION.PADRON_SSS ||
            parametrosImportacion[selectedIndex].idParam === TIPOS_ARCHIVOS_MIGRACION.DEVOLUCIONES_SSS ||
            parametrosImportacion[selectedIndex].idParam === TIPOS_ARCHIVOS_MIGRACION.CAPITA_DESEMPLEO ||
            parametrosImportacion[selectedIndex].idParam === TIPOS_ARCHIVOS_MIGRACION.BAJAS_POR_TRASPASO
        ) {
            dispatch(subirArchivoMigracionNuevoHandler(e.target.files[0], parametrosImportacion[selectedIndex].idParam));
        }
        else {
            dispatch(subirArchivoMigracion(e.target.files[0], parametrosImportacion[selectedIndex].idParam));
        }
        e.target.value = null
    }

    const handleSearch = (e) => {
        dispatch(getArchivosMigracion(selectedDateDesde, selectedDateHasta, selectedTipoArchivo))
    };

    useEffect(() => () => dispatch(setArchivosMigracion([])), []);

    useEffect(() => {
        dispatch(getParametrosImportacion())
        // eslint-disable-next-line
    }, []);

    if (parametrosImportacion === null) {
        return <LoadingBeforeViewData />
    }
    if (parametrosImportacion.length > 0) {
        parametrosImportacion.sort((a, b) => a.descripcion.localeCompare(b.descripcion));
    }
    return (
        <div className={classes.root}>
            <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                <Grid item xs={12} md={10}>
                    <ButtonGroup variant="contained" color="inherit" ref={anchorRef} aria-label="split button" style={{ float: "right" }}>
                        <input
                            accept="*/*"
                            className={classes.input}
                            id="fileSelectorArchivosMigracion"
                            type="file"
                            onChange={handleChangeFile}
                        />
                        <Button component="span" variant="contained" color="inherit" startIcon={<CloudUploadIcon />} style={{ borderRadius: "3px 0px 0px 3px" }} onClick={() => document.querySelector(`#fileSelectorArchivosMigracion`).click()}>{parametrosImportacion[selectedIndex].descripcion}</Button>
                        <Button
                            color="inherit"
                            size="small"
                            aria-controls={open ? 'split-button-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            aria-label="select merge strategy"
                            aria-haspopup="menu"
                            onClick={handleToggle}
                        >
                            <ArrowDropDownIcon />
                        </Button>
                    </ButtonGroup>
                    <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1 }}>
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                                }}
                            >
                                <Paper>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <MenuList id="split-button-menu">
                                            {parametrosImportacion.map((option, index) => (
                                                <MenuItem
                                                    key={option.idParam}
                                                    selected={index === selectedIndex}
                                                    onClick={(event) => handleMenuItemClick(event, index)}
                                                >
                                                    {option.descripcion}
                                                </MenuItem>
                                            ))}
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>

                </Grid>
                <Grid item xs={12} md={10}>
                    <TableSubidaArchivos
                        data={archivos ?? []}
                        setearValor={setearValor}
                        selectedDateDesde={selectedDateDesde}
                        selectedDateHasta={selectedDateHasta}
                        selectedTipoArchivo={selectedTipoArchivo}
                        handleSearch={handleSearch}
                    // paginaActual={list.pagina}
                    // registrosPorPagina={list.registrosPorPagina}
                    // totalRegistros={list.totalRegistros}
                    // ultimaPagina={list.ultimaPagina}
                    // loading={loading}
                    // handleGetData={handleGetData}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

export default SubidaArchivosScreen
